"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonParsingError = exports.FilterKind = exports.ArrayFilterExpression = exports.ChoicesFilterExpression = exports.BooleanFilterExpression = exports.StringFilterExpression = exports.ComparisonFilterExpression = exports.FilterCondition = exports.Order = void 0;
var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (exports.Order = Order = {}));
var FilterCondition;
(function (FilterCondition) {
    FilterCondition["And"] = "&&";
    FilterCondition["Or"] = "||";
})(FilterCondition || (exports.FilterCondition = FilterCondition = {}));
var ComparisonFilterExpression;
(function (ComparisonFilterExpression) {
    ComparisonFilterExpression["Equal"] = "=";
    ComparisonFilterExpression["NotEqual"] = "!=";
    ComparisonFilterExpression["LessThan"] = "<";
    ComparisonFilterExpression["GreaterThan"] = ">";
    ComparisonFilterExpression["EqualOrLessThan"] = "<=";
    ComparisonFilterExpression["EqualOrGreaterThan"] = ">=";
    ComparisonFilterExpression["Match"] = "~";
})(ComparisonFilterExpression || (exports.ComparisonFilterExpression = ComparisonFilterExpression = {}));
var StringFilterExpression;
(function (StringFilterExpression) {
    StringFilterExpression["Equal"] = "=";
    StringFilterExpression["NotEqual"] = "!=";
    StringFilterExpression["Match"] = "~";
    StringFilterExpression["NotMatch"] = "!~";
})(StringFilterExpression || (exports.StringFilterExpression = StringFilterExpression = {}));
var BooleanFilterExpression;
(function (BooleanFilterExpression) {
    BooleanFilterExpression["Equal"] = "=";
    BooleanFilterExpression["NotEqual"] = "!=";
})(BooleanFilterExpression || (exports.BooleanFilterExpression = BooleanFilterExpression = {}));
var ChoicesFilterExpression;
(function (ChoicesFilterExpression) {
    ChoicesFilterExpression["In"] = "=";
    ChoicesFilterExpression["NotIn"] = "!=";
})(ChoicesFilterExpression || (exports.ChoicesFilterExpression = ChoicesFilterExpression = {}));
var ArrayFilterExpression;
(function (ArrayFilterExpression) {
    ArrayFilterExpression["Contains"] = "~";
    ArrayFilterExpression["NotContains"] = "!~";
})(ArrayFilterExpression || (exports.ArrayFilterExpression = ArrayFilterExpression = {}));
var FilterKind;
(function (FilterKind) {
    FilterKind["NumericFilter"] = "NumericFilter";
    FilterKind["DateFilter"] = "DateFilter";
    FilterKind["StringFilter"] = "StringFilter";
    FilterKind["BooleanFilter"] = "BooleanFilter";
    FilterKind["NumericChoicesFilter"] = "NumericChoicesFilter";
    FilterKind["StringChoicesFilter"] = "StringChoicesFilter";
    FilterKind["NumericArrayFilter"] = "NumericArrayFilter";
    FilterKind["StringArrayFilter"] = "StringArrayFilter";
})(FilterKind || (exports.FilterKind = FilterKind = {}));
class JsonParsingError extends Error {
    body;
    constructor(body, cause) {
        super(cause.message, {
            cause: cause,
        });
        this.body = body;
    }
}
exports.JsonParsingError = JsonParsingError;
//# sourceMappingURL=common.js.map